export default __webpack_public_path__ + "static/media/7.901a235a.jpg";